import SvgIcon from "@material-ui/core/SvgIcon";

export const EmptyCircleIcon = ({
  color = "black",
  backgroundColor = "transparent",
  ...props
}) => (
  <SvgIcon
    {...props}
    component="svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="11" fill={backgroundColor} />

    <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" fill="none" />
  </SvgIcon>
);
